










































































































































































































































































































































































import { Component, PropSync } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { InputDatePicker } from '@/components/molecules/InputDatePicker'
import { InputCode } from '@/components/molecules/InputCode'
import { InputCodeTrader } from '@/components/molecules/InputCodeTrader'
import { InputCodeDonor } from '@/components/molecules/InputCodeDonor'
import { InputUserId } from '@/components/molecules/InputUserId'

export interface InputEditAcceptedAndBudgetItem {
  orderDate: {
    input: string
    errorMessage: string
  }
  tempAcceptDate: {
    input: string
    errorMessage: string
  }
  acceptType: {
    input: string
    errorMessage: string
  }
  orderPrice: {
    input: string
    errorMessage: string
  }
  listPrice: {
    input: string
    errorMessage: string
  }
  evaluationPrice: {
    input: string
    errorMessage: string
  }
  applicantUserId: {
    input: string
    errorMessage: string
  }
  traderCode: {
    input: string
    errorMessage: string
  }
  donorCode: {
    input: string
    errorMessage: string
  }
  budgetYear: {
    input: string
    errorMessage: string
  }
  budgetBranchCode: {
    input: string
    errorMessage: string
  }
  budgetDepartmentCode: {
    input: string
    errorMessage: string
  }
  budgetExpenseCode: {
    input: string
    errorMessage: string
  }
  equipType: {
    input: string
    errorMessage: string
  }
}

export const defaultInputEditAcceptedAndBudgetItem = (): InputEditAcceptedAndBudgetItem => ({
  orderDate: {
    input: '',
    errorMessage: ''
  },
  tempAcceptDate: {
    input: '',
    errorMessage: ''
  },
  acceptType: {
    input: '',
    errorMessage: ''
  },
  orderPrice: {
    input: '',
    errorMessage: ''
  },
  listPrice: {
    input: '',
    errorMessage: ''
  },
  evaluationPrice: {
    input: '',
    errorMessage: ''
  },
  applicantUserId: {
    input: '',
    errorMessage: ''
  },
  traderCode: {
    input: '',
    errorMessage: ''
  },
  donorCode: {
    input: '',
    errorMessage: ''
  },
  budgetYear: {
    input: '',
    errorMessage: ''
  },
  budgetBranchCode: {
    input: '',
    errorMessage: ''
  },
  budgetDepartmentCode: {
    input: '',
    errorMessage: ''
  },
  budgetExpenseCode: {
    input: '',
    errorMessage: ''
  },
  equipType: {
    input: '',
    errorMessage: ''
  }
})

const PRICE_PREFIX: string = '￥'

@Component({
  components: {
    InputUserId,
    InputCodeDonor,
    InputCodeTrader,
    InputDatePicker,
    InputCode
  }
})
export default class CollectionEditOrderCollectionAcceptedAndBudgetInfo extends ComponentVue {
  @PropSync('input', {
    type: Object,
    required: true
  })
  inputItem!: InputEditAcceptedAndBudgetItem

  get orderPriceMask(): string {
    return '#'.repeat(7)
  }

  get listPriceMask(): string {
    return '#'.repeat(7)
  }

  get evaluationPriceMask(): string {
    return '#'.repeat(7)
  }

  get budgetYearMask(): string {
    return '#'.repeat(4)
  }

  get pricePrefix(): string {
    return PRICE_PREFIX
  }

  existsErrorMessage(errorMessage: string): boolean {
    return errorMessage !== ''
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }
}
